module.exports = __webpack_public_path__ + "static/media/love-drivelah-4.efe1dae1.jpg";